import ProgressList from '@components/progress-list/progress-list.tsx';
import { ProgressListItem } from '@shared/models/charts/progress-list.model.ts';

const dot = (color: string) => (
  <span className="block size-6 rounded-full" style={{ background: color }} />
);

const data: ProgressListItem[] = [
  { icon: dot('var(--teal)'), name: 'Room Service', percent: 82 },
  { icon: dot('var(--blue-2)'), name: 'Housekeeping', percent: 64 },
  { icon: dot('var(--purple-3)'), name: 'Spa', percent: 47 },
  { icon: dot('var(--orange-1)'), name: 'Laundry', percent: 23 }
];

// height that fits all rows without an inner scrollbar:
// 4 items × 63px (h-15.75) + 3 gaps × 16px = 300
const LIST_HEIGHT = 300;

const Block = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-3 w-full">
    <p className="font-semibold text-gray-700">{title}</p>
    {children}
  </div>
);

function ProgressListShowcase() {
  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-xl font-bold text-gray-800">Progress List</h2>

      <div className="flex flex-col gap-8">
        <div className="flex gap-6">
          <Block title="Populated">
            <ProgressList data={data} height={LIST_HEIGHT} />
          </Block>

          <Block title="Custom colors">
            <ProgressList
              data={data}
              height={LIST_HEIGHT}
              progressColor="var(--primary)"
              trackColor="var(--gray-alpha-200)"
            />
          </Block>
        </div>
        <div className="flex gap-6">
          <Block title="Loading">
            <ProgressList data={[]} loading height={LIST_HEIGHT} />
          </Block>

          <Block title="Empty">
            <ProgressList data={[]} height={LIST_HEIGHT} />
          </Block>
        </div>
      </div>
    </div>
  );
}

export default ProgressListShowcase;
